module.exports = __webpack_public_path__ + "img/day-by-nasa.0c91e30a.jpg";